<template>
  <wsp-modal>
    <v-card class="pb-5"
            flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary"
                   dark
                   dense
                   flat>
          <v-toolbar-title>
            {{ $t('teletag.deleteTeletag.title', { code: teletag.code }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon
                 @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>{{ $t('teletag.deleteTeletag.text')}}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="capitalize primary--text"
               flat
               @click="visible = false">
          {{ $t('global.button.cancel')}}</v-btn>

        <v-btn color="accent"
               class="capitalize white--text mr-2"
               outline
               round
               @click="deleteTeletag">
          {{ $t('global.button.unsubscribe')}}</v-btn>
      </v-card-actions>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import teletagService from '@/services/teletagService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'DeleteTeletag',
  components: {
    [WspModal.name]: WspModal
  },
  props: {
    teletag: {
      type: Object,
      required: true
    }
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  data() {
    return {
      visible: true
    };
  },
  methods: {
    async deleteTeletag() {
      let params = {
        code: this.teletag.code
      };
      let results = await teletagService.disable(params)

      if (results.error) {
        manageErrorService.handle(results.data);
        this.showContent = true
        return;
      }

      this.visible = false
      this.$emit('on-success', {})

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('teletag.deleteTeletag.toast.success'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
